const DesktopLayout = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default DesktopLayout;
